import React from 'react';
import { X, Check } from 'lucide-react';
export function Differences() {
  const notThis = ['A resume rewrite service', 'A passive online course', 'A job board', 'A generic career assessment', 'A "just apply more" approach'];
  const isThis = ['Personal 1:1 guidance', 'Real conversation', 'Practical strategy', 'Confidence building', 'Accountability', 'Support from someone who has hired, led, coached, and built teams'];
  return <section className="py-20 md:py-24 px-6 md:px-12 max-w-5xl mx-auto" data-id="element-40">
      <div className="text-center mb-16" data-id="element-41">
        <h2 className="text-4xl md:text-5xl font-serif mb-4" data-id="element-42">
          More human than a course<span className="text-accent" data-id="element-43">.</span>
          <br data-id="element-44" />
          More practical than advice<span className="text-accent" data-id="element-45">.</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-46">
        <div className="bg-white rounded-2xl p-8 md:p-10 border border-teal/10 shadow-sm" data-id="element-47">
          <h3 className="text-2xl font-serif mb-6 text-ink/60" data-id="element-48">This is not:</h3>
          <ul className="space-y-4" data-id="element-49">
            {notThis.map((item, i) => <li key={i} className="flex items-start gap-3 text-ink/70" data-id="element-50">
                <X className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-51" />
                <span data-id="element-52">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-teal text-white rounded-2xl p-8 md:p-10 shadow-md" data-id="element-53">
          <h3 className="text-2xl font-serif mb-6 text-clay" data-id="element-54">This is:</h3>
          <ul className="space-y-4" data-id="element-55">
            {isThis.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-56">
                <Check className="w-5 h-5 text-sage shrink-0 mt-0.5" data-id="element-57" />
                <span data-id="element-58">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}